<template>
    <div id="sList" @click="$emit('on-click')">
        <p><b><slot name="title"></slot></b> <span><slot name="day"></slot></span></p>
        <p><slot name="des"></slot></p>
    </div>
</template>
<script>
export default {
    methods: {
        
    },
}
</script>
<style lang="">
    #sList{
        padding: 10px 15px;
        background: #fff;
        margin-bottom: 4px;
    }
    #sList:active{
        background: #dee9f8;
    }
    #sList span{
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/List.vue